'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var PeerId = require('peer-id');

var PeerInfo = require('peer-info');

var multiaddr = require('multiaddr');

var mafmt = require('mafmt');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var debug = require('debug');

var log = debug('libp2p:bootstrap');
log.error = debug('libp2p:bootstrap:error');
/**
 * Emits 'peer' events on a regular interval for each peer in the provided list.
 */

var Bootstrap = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Bootstrap, _EventEmitter);

  var _super = _createSuper(Bootstrap);

  /**
   * Constructs a new Bootstrap.
   *
   * @param {Object} options
   * @param {Array<string>} options.list - the list of peer addresses in multi-address format
   * @param {number} [options.interval] - the interval between emitting addresses in milliseconds (default: 10000)
   *
   */
  function Bootstrap() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Bootstrap);

    if (!options.list || !options.list.length) {
      throw new Error('Bootstrap requires a list of peer addresses');
    }

    _this = _super.call(this);
    _this._list = options.list;
    _this._interval = options.interval || 10000;
    _this._timer = null;
    return _this;
  }
  /**
   * Start emitting events.
   */


  _createClass(Bootstrap, [{
    key: "start",
    value: function start() {
      var _this2 = this;

      if (this._timer) {
        return;
      }

      this._timer = setInterval(function () {
        return _this2._discoverBootstrapPeers();
      }, this._interval);

      this._discoverBootstrapPeers();
    }
    /**
     * Emit each address in the list as a PeerInfo.
     */

  }, {
    key: "_discoverBootstrapPeers",
    value: function _discoverBootstrapPeers() {
      var _this3 = this;

      this._list.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(candidate) {
          var ma, peerId, peerInfo;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (mafmt.P2P.matches(candidate)) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return", log.error('Invalid multiaddr'));

                case 2:
                  ma = multiaddr(candidate);
                  peerId = PeerId.createFromB58String(ma.getPeerId());
                  _context.prev = 4;
                  _context.next = 7;
                  return PeerInfo.create(peerId);

                case 7:
                  peerInfo = _context.sent;
                  peerInfo.multiaddrs.add(ma);

                  _this3.emit('peer', peerInfo);

                  _context.next = 15;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context["catch"](4);
                  log.error('Invalid bootstrap peer id', _context.t0);

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[4, 12]]);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * Stop emitting events.
     */

  }, {
    key: "stop",
    value: function stop() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }
  }]);

  return Bootstrap;
}(EventEmitter);

exports = module.exports = Bootstrap;
exports.tag = 'bootstrap';